import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { _cs } from '@togglecorp/fujs';
import { Link as Link$1 } from 'react-router-dom';
import { IoChevronForward } from '../../node_modules/react-icons/io5/index.esm.js';
import { genericMemo, isValidUrl } from '../../utils/index.js';
import Actions from '../Actions/index.js';
import Icons from '../Icons/index.js';
import styles from './styles.css.js';

var _IoChevronForward;
const spacingToStyleMap = {
  none: styles.noSpacing,
  compact: styles.compactSpacing,
  comfortable: styles.comfortableSpacing,
  loose: styles.looseSpacing
};

function Link(props) {
  const {
    disabled,
    className,
    actionsContainerClassName,
    iconsContainerClassName,
    linkElementClassName,
    icons,
    actions,
    to,
    spacing = 'comfortable',
    ...otherProps
  } = props;
  const isExternalLink = React.useMemo(() => typeof to === 'string' && isValidUrl(to), [to]);
  return /*#__PURE__*/React.createElement("div", {
    className: _cs(className, styles.link, spacingToStyleMap[spacing], disabled && styles.disabled)
  }, icons && /*#__PURE__*/React.createElement(Icons, {
    className: _cs(iconsContainerClassName, styles.icons)
  }, icons), isExternalLink ?
  /*#__PURE__*/
  // eslint-disable-next-line jsx-a11y/anchor-has-content
  React.createElement("a", _extends({
    href: to,
    className: _cs(linkElementClassName, styles.linkElement),
    target: "_blank",
    rel: "noopener noreferrer"
  }, otherProps)) : /*#__PURE__*/React.createElement(Link$1, _extends({
    to: to,
    className: _cs(linkElementClassName, styles.linkElement)
  }, otherProps)), (actions || isExternalLink) && /*#__PURE__*/React.createElement(Actions, {
    className: _cs(actionsContainerClassName, styles.actions)
  }, actions, isExternalLink && (_IoChevronForward || (_IoChevronForward = /*#__PURE__*/React.createElement(IoChevronForward, null)))));
}

var index = genericMemo(Link);

export { index as default };
//# sourceMappingURL=index.js.map
